/**
 * The rail's icons, inline rather than from a package: a few small glyphs do not justify
 * a dependency, and inline they inherit `currentColor`, and so the theme.
 */
const base = {
  width: 17,
  height: 17,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** The rail's glyph for the radar. */
export function RadarIcon() {
  return (
    <svg {...base} aria-hidden>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="3.4" />
    </svg>
  );
}

/** The rail's glyph for Table mode. */
export function TableIcon() {
  return (
    <svg {...base} aria-hidden>
      <rect x="3" y="4" width="18" height="16" rx="1.5" />
      <path d="M3 9.5h18M9 9.5V20" />
    </svg>
  );
}

/**
 * A monitor trace, not a page of lines.
 *
 * The route is about whether the pipeline is running and how hard. A pulse says that, and
 * it is the one rail glyph built from neither a circle nor a rectangle, so it does not read
 * as `TableIcon` at a glance.
 */
export function OpsIcon() {
  return (
    <svg {...base} aria-hidden>
      <path d="M2.5 12h4l2.2-6 3.6 12 2.4-6h6.8" />
    </svg>
  );
}

/** A sun glyph for the theme toggle. */
export function ThemeIcon() {
  return (
    <svg {...base} aria-hidden>
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.4v2.2M12 19.4v2.2M2.4 12h2.2M19.4 12h2.2M5.2 5.2l1.6 1.6M17.2 17.2l1.6 1.6M18.8 5.2l-1.6 1.6M6.8 17.2l-1.6 1.6" />
    </svg>
  );
}

/** A small magnifier glyph for search. */
export function SearchIcon() {
  return (
    <svg {...base} width={13} height={13} aria-hidden>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="M15.4 15.4L21 21" />
    </svg>
  );
}

/** The wordmark: four tiles, one accented — a mosaic assembling. */
export function Mark() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" aria-label="Mosaic">
      <rect x="0" y="0" width="9.5" height="9.5" rx="1" fill="var(--s2)" />
      <rect x="12.5" y="0" width="9.5" height="9.5" rx="1" fill="var(--accent)" />
      <rect x="0" y="12.5" width="9.5" height="9.5" rx="1" fill="var(--s1)" />
      <rect x="12.5" y="12.5" width="9.5" height="9.5" rx="1" fill="var(--s3)" />
    </svg>
  );
}
